import React from 'react';
import Switch from "react-switch"

const SwitchInput = ({
  field = { name: '', value: false, onChange: () => {} },
  form,
  ...props
}) => {
  const { name, value, onChange } = field;
  
  // Ensure checked is always a boolean, never undefined
  const checked = value === true || value === 'true' || value === 1 || value === '1';
  
  return (
    <div className={`field-group field-group-switch ${props.className || ""}`}>
      <div className="input-ct">
        <Switch
          {...{
            ...props.switchProps,
            checked: checked,
            onChange: (active) => {
              if (onChange) {
                onChange({
                  target: {
                    type: 'text',
                    value: active ? true : false,
                    name,
                  },
                });
              }
            },
          }}
        />
        <label htmlFor={name}>
          {props.label} {props.required && "*"}
        </label>
      </div>
    </div>
  );
}

export default SwitchInput;
